// Roles & Permissions — the screen's strings in the portal's four languages (2026-10-21). Role names, the
// function names and their group headings come from the server's catalogue and are not in here.
const en = {
  loadFailed: 'Failed to load roles.',
  permFailed: 'Failed to update permission.',
  enterName: 'Enter a role name.',
  created: 'Role "{{name}}" created.',
  createFailed: 'Failed to create role.',
  enterDupName: 'Enter a name for the new role.',
  duplicated: 'Role "{{name}}" created from "{{source}}".',
  dupFailed: 'Failed to duplicate role.',
  nameRequired: 'Role name is required.',
  updated: 'Role updated.',
  updateFailed: 'Failed to update role.',
  confirmDelete: 'Delete role "{{name}}"? This cannot be undone.',
  deleted: 'Role "{{name}}" deleted.',
  deleteFailed: 'Failed to delete role.',
  title: 'Roles & Permissions',
  intro: 'Define roles and tick which features each role can use. Changes take effect the next time a user loads the portal.',
  loading: 'Loading…',
  createTitle: 'Create a new role',
  namePh: 'Role name (e.g. Production Lead)',
  descPh: 'Description (optional)',
  create: 'Create role',
  exists: 'A role named “{{name}}” already exists. Please choose a different name.',
  matrix: 'Permission matrix',
  accountMenu: 'Account menu (admin)',
  rolesShownOne: '{{n}} role shown',
  rolesShownMany: '{{n}} roles shown',
  allRoles: 'All roles',
  findPh: 'Find a permission…',
  collapseAll: 'Collapse all',
  expandAll: 'Expand all',
  colFunction: 'Function',
  inactive: 'inactive',
  userOne: '{{n}} user',
  userMany: '{{n}} users',
  editRole: 'Edit role',
  dupRole: 'Duplicate role',
  delRole: 'Delete role',
  canView: 'Can view',
  canEdit: 'Can edit (implies view)',
  view: 'View',
  edit: 'Edit',
  noRoles: 'No roles yet.',
  note: 'Built-in roles (Admin / SOP Team / User) can be edited but not deleted. A role in use by any user cannot be deleted until those users are reassigned.',
  roleName: 'Role name',
  description: 'Description',
  activeLabel: 'Active (inactive roles grant no access)',
  save: 'Save',
  cancel: 'Cancel',
  dupHint: 'New role will copy every permission (View/Edit) from <b>{{source}}</b>. You can adjust the ticks afterwards.',
  newRoleName: 'New role name',
  duplicate: 'Duplicate',
};

const ko = {
  loadFailed: '역할을 불러오지 못했습니다.',
  permFailed: '권한을 변경하지 못했습니다.',
  enterName: '역할 이름을 입력하세요.',
  created: '역할 "{{name}}"을(를) 만들었습니다.',
  createFailed: '역할을 만들지 못했습니다.',
  enterDupName: '새 역할의 이름을 입력하세요.',
  duplicated: '"{{source}}"에서 역할 "{{name}}"을(를) 만들었습니다.',
  dupFailed: '역할을 복제하지 못했습니다.',
  nameRequired: '역할 이름은 필수입니다.',
  updated: '역할을 수정했습니다.',
  updateFailed: '역할을 수정하지 못했습니다.',
  confirmDelete: '역할 "{{name}}"을(를) 삭제하시겠습니까? 되돌릴 수 없습니다.',
  deleted: '역할 "{{name}}"을(를) 삭제했습니다.',
  deleteFailed: '역할을 삭제하지 못했습니다.',
  title: '역할 및 권한',
  intro: '역할을 정의하고 각 역할이 사용할 수 있는 기능을 체크하세요. 변경 사항은 사용자가 다음에 포털을 열 때 적용됩니다.',
  loading: '불러오는 중…',
  createTitle: '새 역할 만들기',
  namePh: '역할 이름 (예: Production Lead)',
  descPh: '설명 (선택)',
  create: '역할 만들기',
  exists: '“{{name}}” 역할이 이미 있습니다. 다른 이름을 선택하세요.',
  matrix: '권한 매트릭스',
  accountMenu: '계정 메뉴 (관리자)',
  rolesShownOne: '역할 {{n}}개 표시',
  rolesShownMany: '역할 {{n}}개 표시',
  allRoles: '전체 역할',
  findPh: '권한 찾기…',
  collapseAll: '모두 접기',
  expandAll: '모두 펼치기',
  colFunction: '기능',
  inactive: '비활성',
  userOne: '사용자 {{n}}명',
  userMany: '사용자 {{n}}명',
  editRole: '역할 수정',
  dupRole: '역할 복제',
  delRole: '역할 삭제',
  canView: '보기 가능',
  canEdit: '편집 가능 (보기 포함)',
  view: '보기',
  edit: '편집',
  noRoles: '아직 역할이 없습니다.',
  note: '기본 역할 (Admin / SOP Team / User)은 수정할 수 있지만 삭제할 수 없습니다. 사용자가 있는 역할은 해당 사용자를 다른 역할로 옮기기 전까지 삭제할 수 없습니다.',
  roleName: '역할 이름',
  description: '설명',
  activeLabel: '활성 (비활성 역할은 아무 권한도 부여하지 않음)',
  save: '저장',
  cancel: '취소',
  dupHint: '새 역할은 <b>{{source}}</b>의 모든 권한 (보기/편집)을 복사합니다. 이후에 체크를 조정할 수 있습니다.',
  newRoleName: '새 역할 이름',
  duplicate: '복제',
};

const vi = {
  loadFailed: 'Không tải được danh sách vai trò.',
  permFailed: 'Không cập nhật được quyền.',
  enterName: 'Nhập tên vai trò.',
  created: 'Đã tạo vai trò "{{name}}".',
  createFailed: 'Không tạo được vai trò.',
  enterDupName: 'Nhập tên cho vai trò mới.',
  duplicated: 'Đã tạo vai trò "{{name}}" từ "{{source}}".',
  dupFailed: 'Không nhân bản được vai trò.',
  nameRequired: 'Bắt buộc nhập tên vai trò.',
  updated: 'Đã cập nhật vai trò.',
  updateFailed: 'Không cập nhật được vai trò.',
  confirmDelete: 'Xóa vai trò "{{name}}"? Không thể hoàn tác.',
  deleted: 'Đã xóa vai trò "{{name}}".',
  deleteFailed: 'Không xóa được vai trò.',
  title: 'Vai trò & phân quyền',
  intro: 'Định nghĩa vai trò và đánh dấu các chức năng mỗi vai trò được dùng. Thay đổi có hiệu lực vào lần tiếp theo người dùng mở portal.',
  loading: 'Đang tải…',
  createTitle: 'Tạo vai trò mới',
  namePh: 'Tên vai trò (ví dụ Production Lead)',
  descPh: 'Mô tả (không bắt buộc)',
  create: 'Tạo vai trò',
  exists: 'Đã có vai trò tên “{{name}}”. Vui lòng chọn tên khác.',
  matrix: 'Ma trận phân quyền',
  accountMenu: 'Menu tài khoản (admin)',
  rolesShownOne: 'Đang hiện {{n}} vai trò',
  rolesShownMany: 'Đang hiện {{n}} vai trò',
  allRoles: 'Tất cả vai trò',
  findPh: 'Tìm quyền…',
  collapseAll: 'Thu gọn tất cả',
  expandAll: 'Mở tất cả',
  colFunction: 'Chức năng',
  inactive: 'ngừng dùng',
  userOne: '{{n}} người dùng',
  userMany: '{{n}} người dùng',
  editRole: 'Sửa vai trò',
  dupRole: 'Nhân bản vai trò',
  delRole: 'Xóa vai trò',
  canView: 'Được xem',
  canEdit: 'Được sửa (bao gồm xem)',
  view: 'Xem',
  edit: 'Sửa',
  noRoles: 'Chưa có vai trò nào.',
  note: 'Các vai trò có sẵn (Admin / SOP Team / User) có thể sửa nhưng không thể xóa. Vai trò đang có người dùng chỉ xóa được sau khi chuyển những người đó sang vai trò khác.',
  roleName: 'Tên vai trò',
  description: 'Mô tả',
  activeLabel: 'Đang hoạt động (vai trò ngừng hoạt động không cấp quyền nào)',
  save: 'Lưu',
  cancel: 'Hủy',
  dupHint: 'Vai trò mới sẽ sao chép mọi quyền (Xem/Sửa) từ <b>{{source}}</b>. Bạn có thể chỉnh lại các ô đánh dấu sau.',
  newRoleName: 'Tên vai trò mới',
  duplicate: 'Nhân bản',
};

const zh = {
  loadFailed: '无法加载角色。',
  permFailed: '更新权限失败。',
  enterName: '请输入角色名称。',
  created: '已创建角色“{{name}}”。',
  createFailed: '创建角色失败。',
  enterDupName: '请输入新角色的名称。',
  duplicated: '已基于“{{source}}”创建角色“{{name}}”。',
  dupFailed: '复制角色失败。',
  nameRequired: '角色名称为必填项。',
  updated: '角色已更新。',
  updateFailed: '更新角色失败。',
  confirmDelete: '删除角色“{{name}}”？此操作无法撤销。',
  deleted: '已删除角色“{{name}}”。',
  deleteFailed: '删除角色失败。',
  title: '角色与权限',
  intro: '定义角色并勾选每个角色可使用的功能。更改将在用户下次打开门户时生效。',
  loading: '加载中…',
  createTitle: '创建新角色',
  namePh: '角色名称（例如 Production Lead）',
  descPh: '描述（可选）',
  create: '创建角色',
  exists: '名为“{{name}}”的角色已存在，请选择其他名称。',
  matrix: '权限矩阵',
  accountMenu: '账户菜单（管理员）',
  rolesShownOne: '显示 {{n}} 个角色',
  rolesShownMany: '显示 {{n}} 个角色',
  allRoles: '全部角色',
  findPh: '查找权限…',
  collapseAll: '全部收起',
  expandAll: '全部展开',
  colFunction: '功能',
  inactive: '停用',
  userOne: '{{n}} 个用户',
  userMany: '{{n}} 个用户',
  editRole: '编辑角色',
  dupRole: '复制角色',
  delRole: '删除角色',
  canView: '可查看',
  canEdit: '可编辑（包含查看）',
  view: '查看',
  edit: '编辑',
  noRoles: '暂无角色。',
  note: '内置角色（Admin / SOP Team / User）可以编辑但不能删除。仍有用户在使用的角色，需先为这些用户重新分配角色后才能删除。',
  roleName: '角色名称',
  description: '描述',
  activeLabel: '启用（停用的角色不授予任何权限）',
  save: '保存',
  cancel: '取消',
  dupHint: '新角色将复制 <b>{{source}}</b> 的所有权限（查看/编辑）。之后可以再调整勾选。',
  newRoleName: '新角色名称',
  duplicate: '复制',
};

const dictionary = { ns: 'xRoles', en, ko, vi, zh };

export default dictionary;
